module.exports = __webpack_public_path__ + "img/buy-not.112e57e8.png";